// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./public.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#btn-lp-draft:hover span:nth-child(2) {
  display: none;
}
#btn-lp-draft:hover::after {
  content: "Supprimer ?";
}

#modal-wrapper {
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: start;
}

.modal-row-tools-wrapper {
  position: absolute;
  right: 0;
  top: 0;
}

#tools {
  padding: 0;
  min-height: 93vh;
  border-right: 4px solid #151515;
  background-color: #262626;
  overflow: scroll;
}
#tools h6 {
  color: white;
}
#tools #tools-title {
  color: white;
  text-align: center;
  background-color: black;
  padding: 1rem;
  margin: 0;
}
#tools #tools-wrapper {
  padding: 0 0.5rem;
}
#tools .design-accordion {
  margin-top: 0.5rem;
}
#tools .design-accordion .accordion-button {
  font-size: 0.95rem;
  background-color: #262626;
  color: white;
}
#tools .validate-btn {
  background-color: transparent !important;
  color: white !important;
  border: 1px solid white !important;
  width: 100%;
  padding: 1rem !important;
  margin-top: 0.5rem;
}

.row-container .row-actions {
  position: absolute;
  left: 2px;
  top: 2px;
  padding: 0.5rem;
  background-color: rgba(206, 206, 206, 0.4549019608);
  visibility: hidden;
  border-radius: 3px;
  transition: all 0.1s ease-in-out;
  opacity: 0;
}

.row-container:hover .row-actions {
  visibility: visible;
  opacity: 1;
}
.row-container:hover .row-actions:hover {
  background-color: #cecece;
}

.lp-column {
  border: 1px solid green;
}

.content-wrapper {
  position: relative;
  min-height: 30px;
}
.content-wrapper .move-content-wrapper {
  background-color: rgba(206, 206, 206, 0.8862745098);
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 4px;
  padding: 1px;
  border: 1px solid #cecece;
}
.content-wrapper .move-content-wrapper span {
  font-size: 1.2rem;
}
.content-wrapper .delete-content-button-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(206, 206, 206, 0.4549019608);
}
.content-wrapper .delete-content-button-wrapper span {
  font-size: 1.2rem;
}
.content-wrapper .move-content-wrapper .btn:hover,
.content-wrapper .delete-content-button-wrapper .btn:hover {
  background-color: darkblue;
  color: white !important;
}

.edit-column-wrapper {
  position: relative;
}
.edit-column-wrapper .edit-column {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  background-color: rgba(206, 206, 206, 0.7098039216);
  visibility: hidden;
  opacity: 0;
  transition: all 0.1s ease-in;
}

.column-wrapper {
  border: 1px solid rgba(0, 0, 0, 0);
}

.column-wrapper:hover {
  border: 1px solid #cecece;
  cursor: pointer;
}

.small-number-input {
  width: 60px;
}

.row-design-popover {
  z-index: 8000;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}
.video-container iframe,
.video-container object,
.video-container embed {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.image-selector {
  width: 100%;
  height: 150px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.field-actions {
  border: 1px solid #cecece;
  border-radius: 4px;
  padding: 1px;
  background-color: #ececec;
}
.field-actions .btn:hover {
  background-color: darkblue;
  color: white;
}

#form-wrapper #form-title {
  margin-top: -2.5rem;
}
#form-wrapper #form-container {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

input.no-border {
  border: none;
  border-bottom: 1px solid #cecece;
}

.design-title {
  color: #5c5c5c;
  font-weight: 500;
  border-top: 1px solid rgba(236, 236, 236, 0.1843137255);
  margin-top: 1rem;
  color: white;
}

.picker-existing-image {
  width: fit-content;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 25%;
  text-align: center;
}

.field .field-edit {
  display: none;
  visibility: hidden;
  opacity: 0;
  transition: all 0.1s ease-in;
}

.field:hover .field-edit {
  display: block;
  visibility: visible;
  opacity: 1;
}

.field-actions {
  background-color: #ececec;
  padding: 0.4rem;
}

.design-controller {
  margin-top: 2rem;
  border: 1px solid #cecece;
  border-radius: 4px;
  background-color: white;
  padding: 0.5rem;
}
.design-controller label {
  color: #4d4d4d;
}
.design-controller .title {
  background-color: white;
  color: #262626;
  border: 1px solid #cecece;
  text-align: center;
  padding: 0.3rem;
  margin-top: -1.7rem;
  margin-bottom: 0.5rem;
  display: block;
  border-radius: 4px;
}
.design-controller .input-group-text {
  font-size: 0.7rem !important;
}
.design-controller .bi {
  font-size: 1rem;
}

.add-content-group .btn {
  padding: 0.1rem 0.5rem;
  background-color: white;
  color: #262626;
}
.add-content-group .bi {
  font-size: 1.3rem;
}
.add-content-group div {
  font-size: 0.8rem;
}

.focus-animation {
  background-image: linear-gradient(90deg, silver 50%, transparent 50%), linear-gradient(90deg, silver 50%, transparent 50%), linear-gradient(0deg, silver 50%, transparent 50%), linear-gradient(0deg, silver 50%, transparent 50%);
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 15px 3px, 15px 3px, 3px 15px, 3px 15px;
  background-position: left top, right bottom, left bottom, right top;
  animation: border-dance 1s infinite linear;
  padding: 3px;
}

@keyframes border-dance {
  0% {
    background-position: left top, right bottom, left bottom, right top;
  }
  100% {
    background-position: left 15px top, right 15px bottom, left bottom 15px, right top 15px;
  }
}
#landing-v2-nav {
  padding: 0.8rem 1rem;
  background-color: #262626;
  border-bottom: 2px solid #151515;
}
#landing-v2-nav .btn {
  color: white;
  background-color: transparent;
}
#landing-v2-nav .nav a {
  color: white;
  font-weight: 300;
  font-size: 1rem;
}
#landing-v2-nav .nav-pills .nav-link.active {
  background-color: white;
  color: #262626;
}

#infos .info-title {
  background-color: #262626;
  color: white;
  border-radius: 4px;
}

#containers-menu {
  margin: 1rem 0;
  position: relative;
}
#containers-menu #add-wrapper {
  background-color: #262626;
  padding: 1rem;
  color: white;
  border-radius: 4px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

blockquote {
  margin: 1rem 0;
  padding-left: 1.5rem;
  border-left: 5px solid #000000;
  /* Just change the color value and that's it*/
}

#form-actions-wrapper {
  width: 100%;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #cecece;
}

label.radio input:checked + .d-flex {
  color: #ffffff;
  background-color: #000000;
  border: 1px solid #000000;
}

.cursor-pointer {
  cursor: pointer;
}

.tox-tinymce iframe {
  background-color: transparent !important;
}

.design-control {
  margin-top: 1.2rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.design-control:first-child {
  margin-top: 0;
}
.design-control label {
  position: absolute;
  margin: 0;
  padding: 0 4px;
  z-index: 4;
  transform: translate(5px, -55%);
  background-color: white;
  font-weight: 500;
}

.label-design button {
  padding: 0.2rem 0.5rem;
}
.label-design span::before {
  font-size: 2rem;
}

.rotate-icon::before {
  transform: rotate(90deg);
}

.picker {
  position: relative;
}

.swatch {
  width: 56px;
  height: 28px;
  border-radius: 8px;
  border: 3px solid #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.popover {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  border-radius: 9px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}
.popover input {
  margin: auto;
  width: 100%;
  text-align: center;
  border: none;
  padding: 0.4rem;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/LandingsV2/app.scss"],"names":[],"mappings":"AAOQ;EACI,aAAA;AALZ;AAQQ;EACI,sBAAA;AANZ;;AAWA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,kBAAA;EACA,QAAA;EACA,MAAA;AARJ;;AAWA;EACI,UAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAhCC;EAiCD,gBAAA;AARJ;AAUI;EACI,YAAA;AARR;AAWI;EACI,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AATR;AAYI;EACI,iBAAA;AAVR;AAaI;EACI,kBAAA;AAXR;AAaQ;EACI,kBAAA;EACA,yBAxDP;EAyDO,YAAA;AAXZ;AAeI;EACI,wCAAA;EACA,uBAAA;EACA,kCAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AAbR;;AAkBI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,mDAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,UAAA;AAfR;;AAoBI;EACI,mBAAA;EACA,UAAA;AAjBR;AAoBI;EACI,yBAAA;AAlBR;;AAsBA;EACI,uBAAA;AAnBJ;;AAsBA;EACI,kBAAA;EACA,gBAAA;AAnBJ;AAqBI;EACI,mDAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAnBR;AAqBQ;EACI,iBAAA;AAnBZ;AAuBI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,mDAAA;AArBR;AAuBQ;EACI,iBAAA;AArBZ;AAyBI;;EAEI,0BAAA;EACA,uBAAA;AAvBR;;AA2BA;EACI,kBAAA;AAxBJ;AA0BI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,mDAAA;EACA,kBAAA;EACA,UAAA;EACA,4BAAA;AAxBR;;AA4BA;EACI,kCAAA;AAzBJ;;AA4BA;EACI,yBAAA;EACA,eAAA;AAzBJ;;AA4BA;EACI,WAAA;AAzBJ;;AA4BA;EACI,aAAA;AAzBJ;;AA4BA;EACI,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;AAzBJ;AA2BI;;;EAGI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAzBR;;AA6BA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA1BJ;;AA6BA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AA1BJ;AA4BI;EACI,0BAAA;EACA,YAAA;AA1BR;;AAiCI;EACI,mBAAA;AA9BR;AAiCI;EACI,iBAAA;EACA,oBAAA;AA/BR;;AAmCA;EACI,YAAA;EACA,gCAAA;AAhCJ;;AAmCA;EAEI,cAAA;EACA,gBAAA;EACA,uDAAA;EACA,gBAAA;EACA,YAAA;AAjCJ;;AAoCA;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,kBAAA;AAjCJ;;AAqCI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,4BAAA;AAlCR;;AAuCI;EACI,cAAA;EACA,mBAAA;EACA,UAAA;AApCR;;AAwCA;EACI,yBAAA;EACA,eAAA;AArCJ;;AAyCA;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AAtCJ;AAwCI;EACI,cAAA;AAtCR;AAyCI;EACI,uBAAA;EACA,cAzRH;EA0RG,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAvCR;AA0CI;EACI,4BAAA;AAxCR;AA2CI;EACI,eAAA;AAzCR;;AA+CI;EACI,sBAAA;EACA,uBAAA;EACA,cAjTH;AAqQL;AA+CI;EACI,iBAAA;AA7CR;AAgDI;EACI,iBAAA;AA9CR;;AAkDA;EACI,kOAAA;EACA,yDAAA;EACA,uDAAA;EACA,mEAAA;EACA,0CAAA;EACA,YAAA;AA/CJ;;AAkDA;EACI;IACI,mEAAA;EA/CN;EAkDE;IACI,uFAAA;EAhDN;AACF;AAmDA;EACI,oBAAA;EACA,yBAlVC;EAmVD,gCAAA;AAjDJ;AAmDI;EACI,YAAA;EACA,6BAAA;AAjDR;AAoDI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;AAlDR;AAqDI;EACI,uBAAA;EACA,cAlWH;AA+SL;;AAwDI;EACI,yBAxWH;EAyWG,YAAA;EACA,kBAAA;AArDR;;AAyDA;EACI,cAAA;EACA,kBAAA;AAtDJ;AAwDI;EACI,yBAnXH;EAoXG,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAtDR;;AA0DA;EACI,cAAA;EACA,oBAAA;EACA,8BAAA;EACA,6CAAA;AAvDJ;;AA0DA;EACI,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AAvDJ;;AA0DA;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;AAvDJ;;AA0DA;EACI,eAAA;AAvDJ;;AA0DA;EACI,wCAAA;AAvDJ;;AA0DA;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AAvDJ;AAyDI;EACI,aAAA;AAvDR;AA0DI;EACI,kBAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,+BAAA;EACA,uBAAA;EACA,gBAAA;AAxDR;;AA6DI;EACI,sBAAA;AA1DR;AA6DI;EACI,eAAA;AA3DR;;AAgEI;EACI,wBAAA;AA7DR;;AAiEA;EACI,kBAAA;AA9DJ;;AAiEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,4EAAA;EACA,eAAA;AA9DJ;;AAiEA;EACI,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,kBAAA;EACA,0CAAA;AA9DJ;AAgEI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AA9DR","sourcesContent":["@import './public.css';\n\n$bg: #262626;\n$border: #151515;\n\n#btn-lp-draft {\n    &:hover {\n        span:nth-child(2) {\n            display: none;\n        }\n\n        &::after {\n            content: 'Supprimer ?'\n        }\n    }\n}\n\n#modal-wrapper {\n    height: 80%;\n    display: flex;\n    justify-content: center;\n    align-items: start;\n}\n\n.modal-row-tools-wrapper {\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n#tools {\n    padding: 0;\n    min-height: 93vh;\n    border-right: 4px solid $border;\n    background-color: $bg;\n    overflow: scroll;\n\n    h6 {\n        color: white;\n    }\n\n    #tools-title {\n        color: white;\n        text-align: center;\n        background-color: black;\n        padding: 1rem;\n        margin: 0;\n    }\n\n    #tools-wrapper {\n        padding: 0 0.5rem;\n    }\n\n    .design-accordion {\n        margin-top: 0.5rem;\n\n        .accordion-button {\n            font-size: 0.95rem;\n            background-color: $bg;\n            color: white;\n        }\n    }\n\n    .validate-btn {\n        background-color: transparent !important;\n        color: white !important;\n        border: 1px solid white !important;\n        width: 100%;\n        padding: 1rem !important;\n        margin-top: 0.5rem;\n    }\n}\n\n.row-container {\n    .row-actions {\n        position: absolute;\n        left: 2px;\n        top: 2px;\n        padding: 0.5rem;\n        background-color: #cecece74;\n        visibility: hidden;\n        border-radius: 3px;\n        transition: all 0.10s ease-in-out;\n        opacity: 0;\n    }\n}\n\n.row-container:hover {\n    .row-actions {\n        visibility: visible;\n        opacity: 1;\n    }\n\n    .row-actions:hover {\n        background-color: #cecece;\n    }\n}\n\n.lp-column {\n    border: 1px solid green;\n}\n\n.content-wrapper {\n    position: relative;\n    min-height: 30px;\n\n    .move-content-wrapper {\n        background-color: #cececee2;\n        position: absolute;\n        top: 0;\n        right: 0;\n        border-radius: 4px;\n        padding: 1px;\n        border: 1px solid #cecece;\n\n        span {\n            font-size:1.2rem;\n        }\n    }\n\n    .delete-content-button-wrapper {\n        position: absolute;\n        top: 0;\n        left: 0;\n        background-color: #cecece74;\n\n        span {\n            font-size:1.2rem;\n        }\n    }\n\n    .move-content-wrapper .btn:hover,\n    .delete-content-button-wrapper .btn:hover {\n        background-color: darkblue;\n        color: white !important;\n    }\n}\n\n.edit-column-wrapper {\n    position: relative;\n\n    .edit-column {\n        position: absolute;\n        top: 5px;\n        right: 5px;\n        z-index: 1;\n        background-color: #cececeb5;\n        visibility: hidden;\n        opacity: 0;\n        transition: all 0.1s ease-in;\n    }\n}\n\n.column-wrapper {\n    border: 1px solid rgba(0, 0, 0, 0);\n}\n\n.column-wrapper:hover {\n    border: 1px solid #cecece;\n    cursor: pointer;\n}\n\n.small-number-input {\n    width: 60px;\n}\n\n.row-design-popover {\n    z-index: 8000;\n}\n\n.video-container {\n    position: relative;\n    padding-bottom: 56.25%;\n    padding-top: 30px;\n    height: 0;\n    overflow: hidden;\n\n    iframe,\n    object,\n    embed {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n}\n\n.image-selector {\n    width: 100%;\n    height: 150px;\n    background-color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.field-actions {\n    border: 1px solid #cecece;\n    border-radius: 4px;\n    padding: 1px;\n    background-color: #ececec;\n\n    .btn:hover {\n        background-color: darkblue;\n        color: white;\n    }\n}\n\n#form-wrapper {\n    //margin-top: 2rem;\n\n    #form-title {\n        margin-top: -2.5rem;\n    }\n\n    #form-container {\n        padding-top: 1rem;\n        padding-bottom: 1rem;\n    }\n}\n\ninput.no-border {\n    border: none;\n    border-bottom: 1px solid #cecece;\n}\n\n.design-title {\n    //background-color: rgb(47, 47, 47);\n    color: #5c5c5c;\n    font-weight: 500;\n    border-top: 1px solid #ececec2f;\n    margin-top: 1rem;\n    color: white;\n}\n\n.picker-existing-image {\n    width: fit-content;\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    top: 25%;\n    text-align: center;\n}\n\n.field {\n    .field-edit {\n        display: none;\n        visibility: hidden;\n        opacity: 0;\n        transition: all 0.1s ease-in;\n    }\n}\n\n.field:hover {\n    .field-edit {\n        display: block;\n        visibility: visible;\n        opacity: 1;\n    }\n}\n\n.field-actions {\n    background-color: #ececec;\n    padding: 0.4rem;\n}\n\n\n.design-controller {\n    margin-top: 2rem;\n    border: 1px solid #cecece;\n    border-radius: 4px;\n    background-color: white;\n    padding: 0.5rem;\n\n    label {\n        color: #4d4d4d;\n    }\n\n    .title {\n        background-color: white;\n        color: $bg;\n        border: 1px solid #cecece;\n        text-align: center;\n        padding: 0.3rem;\n        margin-top: -1.7rem;\n        margin-bottom: 0.5rem;\n        display: block;\n        border-radius: 4px;\n    }\n\n    .input-group-text {\n        font-size: 0.7rem !important;\n    }\n\n    .bi {\n        font-size: 1rem;\n    }\n}\n\n\n.add-content-group {\n    .btn {\n        padding: 0.1rem 0.5rem;\n        background-color: white;\n        color: $bg;\n    }\n\n    .bi {\n        font-size: 1.3rem;\n    }\n\n    div {\n        font-size: 0.8rem;\n    }\n}\n\n.focus-animation {\n    background-image: linear-gradient(90deg, silver 50%, transparent 50%), linear-gradient(90deg, silver 50%, transparent 50%), linear-gradient(0deg, silver 50%, transparent 50%), linear-gradient(0deg, silver 50%, transparent 50%);\n    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;\n    background-size: 15px 3px, 15px 3px, 3px 15px, 3px 15px;\n    background-position: left top, right bottom, left bottom, right top;\n    animation: border-dance 1s infinite linear;\n    padding: 3px;\n}\n\n@keyframes border-dance {\n    0% {\n        background-position: left top, right bottom, left bottom, right top;\n    }\n\n    100% {\n        background-position: left 15px top, right 15px bottom, left bottom 15px, right top 15px;\n    }\n}\n\n#landing-v2-nav {\n    padding: 0.8rem 1rem;\n    background-color: $bg;\n    border-bottom: 2px solid $border;\n\n    .btn {\n        color: white;\n        background-color: transparent;\n    }\n\n    .nav a {\n        color: white;\n        font-weight: 300;\n        font-size: 1rem;\n    }\n\n    .nav-pills .nav-link.active {\n        background-color: white;\n        color: $bg;\n    }\n}\n\n#infos {\n    .info-title {\n        background-color: $bg;\n        color: white;\n        border-radius: 4px;\n    }\n}\n\n#containers-menu {\n    margin: 1rem 0;\n    position: relative;\n\n    #add-wrapper {\n        background-color: $bg;\n        padding: 1rem;\n        color: white;\n        border-radius: 4px;\n        text-align: center;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n}\n\nblockquote {\n    margin: 1rem 0;\n    padding-left: 1.5rem;\n    border-left: 5px solid #000000;\n    /* Just change the color value and that's it*/\n}\n\n#form-actions-wrapper {\n    width: 100%;\n    background-color: white;\n    border-radius: 4px;\n    border: 1px solid #cecece;\n}\n\nlabel.radio input:checked+.d-flex {\n    color: #ffffff;\n    background-color: #000000;\n    border: 1px solid #000000;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.tox-tinymce iframe {\n    background-color: transparent !important;\n}\n\n.design-control {\n    margin-top: 1.2rem;\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    width: 100%;\n\n    &:first-child {\n        margin-top: 0;\n    }\n\n    label {\n        position: absolute;\n        margin: 0;\n        padding: 0 4px;\n        z-index: 4;\n        transform: translate(5px, -55%);\n        background-color: white;\n        font-weight: 500;\n    }\n}\n\n.label-design {\n    button {\n        padding: 0.2rem 0.5rem;\n    }\n\n    span::before {\n        font-size: 2rem;\n    }\n}\n\n.rotate-icon {\n    &::before {\n        transform: rotate(90deg);\n    }\n}\n\n.picker {\n    position: relative;\n}\n\n.swatch {\n    width: 56px;\n    height: 28px;\n    border-radius: 8px;\n    border: 3px solid #fff;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n}\n\n.popover {\n    position: absolute;\n    top: calc(100% + 2px);\n    left: 0;\n    border-radius: 9px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n\n    input {\n        margin:auto;\n        width:100%;\n        text-align: center;\n        border:none;\n        padding:0.4rem;\n        border-radius:4px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
